export const STORAGE_NAMESPACE = '@pluox';
